import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=10336fdc"
import script from "./PeriodSelector.vue?vue&type=script&lang=js"
export * from "./PeriodSelector.vue?vue&type=script&lang=js"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=10336fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports